import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { LogoPresenter } from './logo.presenter';
import { LogoViewModel } from './logo.view.model';

import { JuiButton } from '@jump-tech-frontend/core-components-angular';

@Component({
  selector: 'logo-component',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  imports: [NgbDropdownModule, JuiButton],
  providers: [LogoPresenter, NgbActiveModal]
})
export class LogoComponent implements OnInit {
  @Input() showClose = false;
  @Input() showHelp = false;
  @Output() helpRequested: EventEmitter<void> = new EventEmitter();
  vm: LogoViewModel;

  constructor(private logoPresenter: LogoPresenter, private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.logoPresenter.load(vm => {
      this.vm = vm;
      this.vm.showClose = this.showClose;
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }

  requestHelp() {
    this.helpRequested.emit();
  }
}
